import React from "react";
import { Typography, Tooltip, IconButton, Box } from "@mui/material";

import { Construction } from "@mui/icons-material";

const TestServer = () => {
  return (
    <Box
      sx={{
        width: "100%",
        bgcolor: "#862633",
        color: "white",
        py: 0.75,
        px: 2,
        textAlign: "center",
        position: "fixed",
        top: 0,
        left: 0,
        zIndex: 1200,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 1,
        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
        "& .MuiSvgIcon-root": {
          fontSize: "1.1rem",
        },
      }}
    >
      <Construction />
      <Typography variant="body2" sx={{ fontWeight: 500, fontSize: "0.85rem" }}>
        Development Environment - This is a TEST server.
      </Typography>
    </Box>
  );
};

export default TestServer;
